import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVehicles } from '../../store/reducers/vehicleReducer';
import PriceDetails from './PriceDetails';
import './PlanSelection.css';
import Spinner from './../Spinner';

const iconMap = {
  'TW': {
    type: 'Two',
    icon: '/assets/bike/bike.svg',
    selectedIcon: '/assets/bike/bike-white.svg'
  },
  'PC': {
    type: 'Four',
    icon: '/assets/car/car-dark.svg',
    selectedIcon: '/assets/car/car-white.svg'
  },
  'CV': {
    type: 'CV',
    icon: '/assets/lcv/lcv-dark.svg',
    selectedIcon: '/assets/lcv/lcv-white.svg'
  },
  'TH': {
    type: 'TH',
    icon: '/assets/hcv/hcv-dark.svg',
    selectedIcon: '/assets/hcv/hcv-white.svg'
  }
};

const PlanSelection = ({ onSelect }) => {
  const dispatch = useDispatch();
  const vehicleListState = useSelector((state) => state.vehicleList || {}); // From Reducers
  const { apiResponse, loading, apiErrorMsg } = vehicleListState;

  const vehicleMaster = apiResponse.data;
  const [selected, setSelected] = useState(null);
  const [vehicleData, setVehicleData] = useState([]);

const location = useLocation();
const vehicleSectionRef = useRef(null);


  useEffect(() => {
    if (!vehicleMaster || vehicleMaster.length === 0) {
      dispatch(fetchVehicles());
    }
    else {
          const mappedVehicles = vehicleMaster.map(vehicle => {
            
            const match = iconMap[vehicle.vehicle_type_code];
            return {
              ...vehicle,
              type: match?.type || vehicle.vehicle_type_name,
              icon: match?.icon || '',
              selectedIcon: match?.selectedIcon || ''
            };
          });
          setVehicleData(mappedVehicles);

          // Set default selected based on mapped data
          const defaultVehicle = mappedVehicles.find(v => v.vehicle_type_code === 'PC');
          console.log("defaultVehicle",defaultVehicle);
          if (defaultVehicle) {
            setSelected({ code: defaultVehicle.vehicle_type_code, id: defaultVehicle.vehicle_type_id });
          }
    }
  }, [dispatch, vehicleMaster]);

  useEffect(() => {
    if (onSelect) {
      onSelect(selected);
      localStorage.setItem('vTypeId',JSON.stringify(selected?.id));
    }
  }, [selected, onSelect]);


 useEffect(() => {
  if (location.state?.scrollToVehicleSection && vehicleSectionRef.current) {
    vehicleSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // vehicleSectionRef.current.focus(); // Optional
  }
}, [location]);


console.log("scrollToVehicleSection",location.state?.scrollToVehicleSection);
console.log("vehicleDatavehicleDatavehicleData",vehicleData);
  return (
    <div className='vehicles'>
   
    <div 
      className="vehicle-section"
      ref={vehicleSectionRef}
      tabIndex={-1} // Makes it focusable
    >
      
    <span className='plan-details'>Plan Details</span>
      <div className="scroll-container">
        {vehicleData.map(v => (
          <div>
          <div
            key={v.vehicle_type_id}
            // className={`vehicle-icon ${selected.code === v.vehicle_type_code ? 'selected' : ''}`}
            className={`vehicle-icon ${selected?.code === v.vehicle_type_code ? 'selected' : ''}`}

            // onClick={() => setSelected(v.vehicle_type_code)}
            onClick={() => setSelected({ code: v.vehicle_type_code, id: v.vehicle_type_id })}
            >
            <img src={selected?.code === v.vehicle_type_code ? v.selectedIcon : v.icon} alt={v.type} />
            {/* <img src={selected?.code === v.vehicle_type_code ? v.selectedIcon : v.icon} alt={v.type} /> */}

          </div>
          <span className='vtype-name'>{v.vehicle_type_name}</span>
          </div>
        ))}
      </div>

      {selected && <PriceDetails code={selected.code} id={selected.id} />}
    </div>
    </div>
  )
};

export default PlanSelection;
